/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import CaptchaInfo from 'DesignSystem/CaptchaInfo/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Captcha/Content"
  
}) {
  return (<React.Fragment
>
<CaptchaInfo
  viewPath={`${viewPath}/CaptchaInfo`}
/>
{children}
</React.Fragment>)
}